<template>
  <b-modal
    id="modal-billing-subscription"
    hide-header
    hide-footer
    ok-only
    ok-title="Accept"
    centered
    size="lg"
    title="Large Modal"
    modal-class="custom__modal--large"
    @show="handleOpenModal"
  >
    <div class="section">
      <ModalHeader
        v-if="step === 1"
        :left-text="'Kembali'"
        :middle-text="'Pilih Tambahan'"
        :is-rigt-column="true"
        :right-text="'Selanjutnya'"
        :right-function="nextSubmit"
        :left-function="prevPage"
        :isDisabled="isNextButtonDisabled"
      />
      <ModalHeader
        v-if="step === 2"
        :left-text="'Kembali'"
        :middle-text="
          selectedId === 'user'
            ? 'Tambah Pengguna'
            : selectedId === 'branch'
            ? 'Tambah Cabang'
            : selectedId === 'extend_user'
            ? 'Perpanjang masa berlaku pengguna'
            : 'Perpanjang masa berlaku cabang'
        "
        :is-rigt-column="true"
        :right-text="'Selanjutnya'"
        :right-function="nextSubmit"
        :left-function="prevPage"
        :isDisabled="isNextButtonDisabled"
      />
      <ModalHeader
        v-else-if="step === 3"
        :left-text="'Kembali'"
        :middle-text="'Pilih Metode Pembayaran'"
        :is-rigt-column="true"
        :right-text="'Bayar'"
        :right-function="createSubscription"
        :left-function="prevPage"
        :isDisabled="isPaymentSelected"
      />
      <!-- Spinner -->
      <b-col
        v-if="isLoading == true"
        class="d-flex justify-content-center mt-5 pt-5"
      >
        <b-spinner
          style="width: 3rem; height: 3rem"
          label="Loading..."
        />
      </b-col>
      <b-container
        v-else
        class="mt-15"
      >
        <!-- Step 1 -->
        <b-container v-if="step === 1">
          <b-row class="justify-content-center mb-2">
            <b-col cols="12" lg="3" md="6" v-if="typeExtend === 'user'">
              <b-card
                class="border-12 mb-0"
                :class="selectedId === 'user' ? 'selected' : ''"
                style="height: 85px; cursor: pointer"
                @click="selectSubscription('user')"
              >
                <div class="d-flex align-items-center h-100" style="gap: 14px">
                  <img
                    src="@/assets/images/icons/add-user.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                  <div class="d-flex flex-column">
                    <h5 class="text-dark size14 fw-bold-800 mb-0">
                      Tambah Pengguna
                    </h5>
                  </div>
                </div>
              </b-card>
            </b-col>
            <b-col cols="12" lg="3" md="6" v-if="typeExtend === 'user'">
              <b-card
                class="border-12 mb-0"
                :class="selectedId === 'extend_user' ? 'selected' : ''"
                style="height: 85px; cursor: pointer"
                @click="selectSubscription('extend_user')"
              >
                <div class="d-flex align-items-center h-100" style="gap: 14px">
                  <img
                    src="@/assets/images/icons/user-renewal.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                  <div class="d-flex flex-column">
                    <h5 class="text-dark size14 fw-bold-800 mb-0">
                      Perpanjang Pengguna
                    </h5>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="justify-content-center mb-2">
            <b-col cols="12" lg="3" md="6" v-if="typeExtend === 'branch'">
              <b-card
                class="border-12 mb-0"
                :class="selectedId === 'branch' ? 'selected' : ''"
                style="height: 85px; cursor: pointer"
                @click="selectSubscription('branch')"
              >
                <div class="d-flex align-items-center h-100" style="gap: 14px">
                  <img
                    src="@/assets/images/icons/add-cabang.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                  <div class="d-flex flex-column">
                    <h5 class="text-dark size14 fw-bold-800 mb-0">
                      Tambah Cabang
                    </h5>
                  </div>
                </div>
              </b-card>
            </b-col>
            <b-col cols="12" lg="3" md="6" v-if="typeExtend === 'branch'">
              <b-card
                class="border-12 mb-0"
                :class="selectedId === 'extend_branch' ? 'selected' : ''"
                style="height: 85px; cursor: pointer"
                @click="selectSubscription('extend_branch')"
              >
                <div class="d-flex align-items-center h-100" style="gap: 14px">
                  <img
                    src="@/assets/images/icons/cabang-renewal.svg"
                    alt=""
                    style="width: 46px; height: 46px"
                  />
                  <div class="d-flex flex-column">
                    <h5 class="text-dark size14 fw-bold-800 mb-0">
                      Perpanjang Cabang
                    </h5>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
        <!-- Step 2 -->
        <b-container v-if="step === 2">
          <b-row class="justify-content-center">
            <b-col
              cols="12"
              md="10"
              lg="8"
            >

              <div>
                <b-form-group
                  class="custom__form--input"
                  style="width: fit-content"
                >
                  <label
                    for="v-bank"
                    class="text-capitalize"
                    >Jumlah
                    {{ type[payloadSubscription.type] }}
                    <span class="text-danger">*</span></label
                  >
                  <b-form-spinbutton
                    id="demo-sb"
                    v-model="payloadSubscription.count"
                    min="1"
                    max="100"
                    class="custom__input"
                  />
                </b-form-group>
              </div>

              <div>
                <b-form-group class="custom__form--input">
                  <label for="v-bank"
                    >Paket Berlangganan
                    <span class="text-danger">*</span></label
                  >
                  <v-select
                    v-model="payloadSubscription.subscription_package"
                    label="renewal_name"
                    :options="optionsSubcription"
                    placeholder="Pilih Paket"
                  >
                    <template #option="{ renewal_name, price, sell_price }">
                      <span
                        >{{ renewal_name }}
                        <span
                          v-if="price > sell_price"
                          style="text-decoration: line-through"
                          >{{ price | formatAmount }}</span
                        >&nbsp;<span>{{
                          sell_price | formatAmount
                        }}</span></span
                      >
                    </template>
                  </v-select>
                </b-form-group>
              </div>

              <div v-if="payloadSubscription.type === 'extend_branch' || payloadSubscription.type === 'extend_user'">
                <b-form
                  ref="form"
                  class="repeater-form"
                  @submit.prevent="repeateAgain"
                >
                  <b-row
                    v-for="(item, index) in items"
                    :id="item.id"
                    :key="item.id"
                    ref="row"
                  >
                    <b-col cols="5" md="4">
                      <b-form-group class="custom__form--input">
                        <label for="v-branch"
                          >Cabang <span class="text-danger">*</span></label
                        >
                        <v-select
                          id="v-branch"
                          v-model="items[index].branch_id"
                          placeholder="Pilih Cabang"
                          class="custom__input"
                          :options="optionsBranch"
                          label="name"
                          @search="onSearchBranch"
                        >
                          <template v-slot:option="option" v-if="payloadSubscription.type !== 'extend_user'">
                            <span :class="option.icon"></span>
                            {{ option.name }}
                            <span v-if="option.renewal_status !== 'subscribe-flex-plan'">({{ option.renewal_end_date | formatDateWithTime }})</span>
                            <span v-if="option.renewal_status === 'subscribe-flex-plan'">(Credit: {{ option.subscription_credit | formatInvoice }})</span>
                          </template>
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="5" md="4" v-if="payloadSubscription.type !== 'extend_branch'">
                      <b-form-group class="custom__form--input">
                        <label for="v-user"
                          >User <span class="text-danger">*</span></label
                        >
                        <v-select
                          id="v-user"
                          v-model="items[index].user_id"
                          placeholder="Pilih Pengguna"
                          class="custom__input"
                          :options="optionsUser"
                          label="name"
                          @search="onSearchUser"
                        >
                          <template v-slot:option="option">
                            <span :class="option.icon"></span>
                            {{ option.name }} ({{ option.renewal_end_date | formatDateWithTime }})
                          </template>
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="2"
                      lg="3"
                      md="4"
                      class="align-self-center"
                    >
                      <b-button
                        variant="outline-danger"
                        class=""
                        @click="removeItem(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                          class="mr-25"
                        />
                        <span>Hapus</span>
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <hr />
                    </b-col>
                  </b-row>
                </b-form>
                <b-button
                  v-if="payloadSubscription.count === items.length + 1"
                  variant="primary"
                  @click="repeateAgain"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>Tambah {{ type[payloadSubscription.type] }}</span>
                </b-button>
              </div>

              <div
                class="mt-4"
                v-if="payloadSubscription.subscription_package.sell_price"
              >
                <h4 class="font-weight-bold">Total dibayar</h4>
                <h1 class="font-weight-bold">
                  {{
                    payloadSubscription.subscription_package.sell_price
                      | formatAmount
                  }}
                </h1>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <!-- Step 3 -->
        <b-container v-if="step === 3">
          <b-row class="justify-content-center h-100 bg-white pb-5">
            <b-col
              cols="10"
              md="6"
              lg="3"
            >
              <b-card
                class="card__subscription border-15 bg-secondary text-white text-center"
              >
                <div class="discount-tag fw-bold-900 bg-warning">
                  <div>Best Offer</div>
                </div>
                <div class="mb-2">
                  {{ payloadSubscription.subscription_package.renewal_name }}
                </div>
                <div class="mb-2">
                  {{
                    payloadSubscription.subscription_package.renewal_description
                  }}
                </div>

                <template #footer>
                  <div class="strike-through">
                    {{
                      payloadSubscription.subscription_package.price
                        | formatAmount
                    }}
                  </div>
                  <div class="mb-2 size22">
                    {{
                      payloadSubscription.subscription_package.sell_price
                        | formatAmount
                    }}
                  </div>
                </template>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <b-col cols="12" md="6">                
              <label for="payment">Pilih Metode Pembayaran</label>
              <v-select id="payment" v-model="selectedPayment" label="name" :options="paymentList"
                :reduce="(paymentList) => paymentList.value" placeholder="Pilih Metode Pembayaran">
                <template #selected-option="{ image, name }">
                    <div class="d-flex align-items-center" style="gap: 6px">
                      <img :src="image" :alt="name"
                        style="width: 30px" />
                      <p class="size12 mb-0">{{ name }}</p>
                    </div>
                  </template>
                  <template #option="{ image, name }">
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <img :src="image" :alt="name"
                        style="width: 30px" />
                      <p class="mb-0">{{ name }}</p>
                    </div>
                  </template>
              </v-select>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BImg,
  BCard,
  BButton,
  BFormCheckbox,
  BFormRadio,
  BSpinner,
  BFormSpinbutton,
  BFormSelect,
  BForm,
} from 'bootstrap-vue';
import vSelect from 'vue-select';

import {
  checkPermission,
  successNotification,
  errorNotification,
} from '@/auth/utils';

import ModalHeader from '@/components/ModalHeader.vue';

export default {
  props: ['typeExtend', 'subscriptionCredit', 'renewalStatus' , 'renewalEndDate', 'subscriptionMethod'],
  components: {
    BModal,
    BRow,
    BCol,
    vSelect,
    BImg,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BContainer,
    BFormCheckbox,
    BFormRadio,
    BSpinner,
    ModalHeader,
    BFormSpinbutton,
    BFormSelect,
    BForm,
  },
  data() {
    return {
      value: 1,
      step: 1,
      subscription: [],
      selectedId: '',
      selectedPayment: '',
      isLoading: false,
      selectedAddition: null,
      payloadSubscription: {
        type: '',
        count: 1,
        subscription_package: '',
        count: 1,
        payment_method: '',
        payment_provider_name: 'xendit',
        branches: [],
        users: [],
        subscription_type: null
      },
      optionsAddition: [
        {
          label: 'Tambah Cabang',
          value: 'branch',
        },
        {
          label: 'Tambah User',
          value: 'user_subscription',
        },
        {
          label: 'Tambah Masa Aktif Cabang',
          value: 'extend_branch',
        },
        {
          label: 'Tambah Masa Aktif User',
          value: 'extend_user',
        },
      ],
      optionsSubcription: [],
      optionsSubscriptionType: [
        { value: null, text: 'Please select an option' },
        { value: 'main_subscription', text: 'Main Subcription' },
        { value: 'user_subscription', text: 'User Subscription' },
        { value: 'branch_subscription', text: 'Branch Subscription' },
        { value: 'extend_user_subscription', text: 'Extend User Subscription' },
        {
          value: 'extend_branch_subscription',
          text: 'Extend Branch Subscription',
        },
      ],
      type: {
        branch: 'Cabang',
        user: 'Pengguna',
        extend_user: 'Pengguna',
        extend_branch: 'Cabang',
      },
      items: [
        {
          id: 1,
          selected: 'male',
          selected1: 'designer',
          prevHeight: 0,
          user_id: null,
          branch_id: null
        },
      ],
      nextTodoId: 2,
      optionsUser: [],
      optionsBranch: [],
      subscriptionType: {
        branch: 'branch_subscription',
        user: 'user_subscription',
        extend_user: 'extend_user_subscription',
        extend_branch: 'extend_branch_subscription',
      },
      paymentList: [],
    };
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    };
  },
  created() {
    this.getItems();
  },
  computed: {
    hasSelectedItem() {
      return this.selectedId !== '';
    },
    isNextButtonDisabled() {
      return !this.hasSelectedItem;
    },
    isPaymentSelected() {
      return !this.selectedPayment;
    },
    highestDiscountSubscription() {
      if (this.subscription.length === 0) {
        return [];
      }

      // Find the subscription with the highest discount_percent
      const highestDiscount = Math.max(
        ...this.subscription.map((item) => item.discount_percent)
      );
      return highestDiscount;
    },
  },
  watch: {
    'payloadSubscription.type': 'getPackageBranchUser',
    'payloadSubscription.count': 'getPackageBranchUser',
  },
  mounted() {
    
  },
  methods: {
    async getPaymentMethod() {
      try {
        const response = await this.$http.get('/available-payment-methods')
        this.paymentList = response.data.data.map((item) => {
          return {
            name: item.payment_name,
            value: item.payment_code,
            image: item.logo_url,
          }
        })
      } catch (error) {
        
      }
    },
    async handleOpenModal() {
      await this.getPaymentMethod()
      await this.getBranch()
      await this.getUser()
    },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    getPackageBranchUser() {
      const { type, count, subscription_type } = this.payloadSubscription;
      
      this.payloadSubscription.subscription_package = ''
      this.payloadSubscription.branches = []
      this.payloadSubscription.users = []
      const queryParams = { type, count };

      this.$store
        .dispatch('subscribe/getPackageBranchUser', {
          params: queryParams,
        })
        .then((result) => {
          this.optionsSubcription = result.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getItems() {
      this.$store
        .dispatch('subscribe/getData')
        .then((result) => {
          this.subscription = result.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    preparePayload() {
      const form = new FormData();

      const payload = {
        ...this.payloadSubscription,
        type: this.subscriptionType[this.payloadSubscription.type],
        subscription_renewal_id: this.payloadSubscription.subscription_package.id,
        payment_method: this.payloadSubscription.payment_method,
        payment_provider_name: 'xendit',
        branches: this.items.map((item) => item.branch_id),
        users: this.items.map((item) => item.user_id),
      };

      for (const key in payload) {
        if (
          payload.hasOwnProperty(key) &&
          payload[key] != null &&
          key !== 'branches' &&
          key !== 'users' &&
          key !== 'subscription_package'
        ) {
            form.append(key, payload[key]);
          }
      }

      // Append branches uuids
      if (payload.branches.length > 0 && payload.branches[0] !== null) {
        payload.branches.forEach((branch, index) => {
          form.append(`branches[${index}]`, branch.uuid);
        });
      }
      // Append users uuids
      if (payload.users.length > 0 && payload.users[0] !== null) {
        payload.users.forEach((user, index) => {
          form.append(`users[${index}]`, user.uuid);
        });
      }
      return form;
    },
    createSubscription() {
      if (this.step === 3) {
        if (!this.selectedPayment) {
          errorNotification(this,
            'Silahkan pilih metode pembayaran terlebih dahulu.'
          );
          return;
        }
        this.payloadSubscription.subscription_type = this.subscriptionType[this.selectedId];
        this.payloadSubscription.payment_method = this.selectedPayment;

        const statusSubscribe = {
          flex_plan: 'subscribe-flex-plan',
          fix_plan: 'subscribe'
        }
        const renewalStatus = this.items[0]?.branch_id?.renewal_status
        const renewalEndDate = this.items[0]?.branch_id?.renewal_end_date
        const subscriptionCredit = this.items[0]?.branch_id?.subscription_credit

        if (statusSubscribe[this.subscriptionMethod] !== renewalStatus && this.selectedId !== 'branch' && this.selectedId !== 'extend_user') {
          this.$swal({
            title: `Saat ini Anda masih memiliki langganan ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Flex Plan' : 'Toqoo Fix Plan'} dengan ${renewalStatus === 'subscribe-flex-plan' ? 'credit sebesar ' + subscriptionCredit + ' Transaksi' : 'masa aktif sampai ' + renewalEndDate}`,
            text: `Jika proses pembayaran ini dilanjutkan, maka ${renewalStatus === 'subscribe-flex-plan' ? 'credit' : 'masa aktif'} Anda di ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Flex Plan' : 'Toqoo Fix Plan'} akan hangus dan metode berlangganan Anda berubah menjadi ${renewalStatus === 'subscribe-flex-plan' ? 'Toqoo Fix Plan' : 'Toqoo Flex Plan'}. \nApakah Anda yakin ingin melanjutkan proses pembayaran ini?`,
            icon: 'warning',
            showCancelButton: true,
            width: 600,
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
              title: 'text-danger size16 font-weight-bolder'
            },
            buttonsStyling: false,
            color: '#e52a34'
          }).then((result) => {
            if (result.isConfirmed) {
              this.postSubscription()
            }
          });
        } else {
          this.postSubscription()
        }
      }
    },
    postSubscription() {
      this.isLoading = true;
      const payload = this.preparePayload()
      this.$store
        .dispatch('subscribe/postSubscription', { payload })
        .then((response) => {
          this.$bvModal.hide('modal-subscribe');
          const uuid = response.data.data.uuid;

          this.$router.push({
            name: 'billing.index',
            params: { id: uuid },
          });
        })
        .catch((error) => {
          this.isLoading = false;
          errorNotification('Error creating subscription.');
          console.error(error);
        });
    },
    selectSubscription(id) {
      this.selectedId = id;
      this.payloadSubscription.type = id
      // this.step = 2
    },
    selectPayment(paymentMethod) {
      this.selectedPayment = paymentMethod;
    },
    nextSubmit() {
      if (this.step === 1) {
        this.step = 2;
      } else if (this.step === 2) {
        this.step = 3;
      }
    },
    prevPage() {
      // if (this.step === 2) {
      //   this.step = 1;
      // } else {
      //   this.$bvModal.hide('modal-user-branch-active-period');
      // }
      if (this.step === 2) {
        this.step = 1;
        // this.selectedId = "";
        // this.formPayload = {
        //   duration_month: "",
        //   amount: 1,
        //   total: "",
        //   payment_provider_name: "xendit",
        // };
        // this.inputsItem = [
        //   {
        //     uuid: "",
        //     phone: "",
        //     renewal_end_date: "",
        //   },
        // ];
        // this.selectedPayment = "";
      } else if (this.step === 3) {
        this.step = 2;
      } else {
        this.$bvModal.hide("modal-billing-subscription");
      }
    },
    getSelectedSubscription(propertyName) {
      const selectedRenewal = this.subscription.find(
        (item) => item.id === this.selectedId
      );
      return selectedRenewal ? selectedRenewal[propertyName] : '';
    },
    getBranch() {
      this.$store
        .dispatch('cabang/getData', { uuid: '', params: '' })
        .then((result) => {
          this.optionsBranch = result.data.data.data
          .filter((e) => !e.is_main_branch)
          .map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date,
              renewal_status: e.renewal_status,
              subscription_credit: e.subscription_credit
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchBranch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchBranch(loading, search, this);
      } else {
        loading(true);
        setTimeout(() => {
          this.optionsBranch = [];
          this.getBranch();
          loading(false);
        }, 500);
      }
    },
    searchBranch: _.debounce((loading, search, vm) => {
      vm.$store
        .dispatch('cabang/getData', {
          uuid: '',
          params: {
            search,
          },
        })
        .then((response) => {
          vm.optionsBranch = response.data.data.data
          .filter((e) => !e.is_main_branch)
          .map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date,
              renewal_status: e.renewal_status,
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
    }, 300),
    getUser() {
      this.$store
        .dispatch('users/getData', { uuid: '', params: '' })
        .then((result) => {
          this.optionsUser = result.data.data.data.map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchUser(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUser(loading, search, this);
      } else {
        loading(true);
        setTimeout(() => {
          this.optionsUser = [];
          this.getUser();
          loading(false);
        }, 500);
      }
    },
    searchUser: _.debounce((loading, search, vm) => {
      vm.$store
        .dispatch('users/getData', {
          uuid: '',
          params: {
            search,
          },
        })
        .then((response) => {
          vm.optionsUser = response.data.data.data.map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
    }, 300),
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.selected {
  box-shadow: 0 10px 10px 0 #52cec2;
}
</style>
